module.exports = __webpack_public_path__ + "fonts/poppins-v21-latin-600.woff2";